module.exports = __webpack_public_path__ + "img/img02.ce35f559.jpg";